import { render, staticRenderFns } from "./parallax.vue?vue&type=template&id=3936dcc3&lang=html&"
import script from "./parallax.vue?vue&type=script&lang=js&"
export * from "./parallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3936dcc3')) {
      api.createRecord('3936dcc3', component.options)
    } else {
      api.reload('3936dcc3', component.options)
    }
    module.hot.accept("./parallax.vue?vue&type=template&id=3936dcc3&lang=html&", function () {
      api.rerender('3936dcc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/parallax.vue"
export default component.exports